import { render, staticRenderFns } from "./AttendancePeriod.vue?vue&type=template&id=24096d9f&scoped=true&"
import script from "./AttendancePeriod.vue?vue&type=script&lang=js&"
export * from "./AttendancePeriod.vue?vue&type=script&lang=js&"
import style0 from "./AttendancePeriod.vue?vue&type=style&index=0&id=24096d9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24096d9f",
  null
  
)

export default component.exports